import Item from './item';
import { EFFECT_TYPE, ITEM_TYPE } from '../Helpers/constants';

const EFFECT = {
    type: null,
    value: null,
};

const EFFECT_LIST = {
    'smallGainHP': {
        type: EFFECT_TYPE.GAIN.HP,
        value: 5,
    }
}

export const POTION_LIST = {
    potionLittleHP: {
        id: 'potionLittleHP',
        type: ITEM_TYPE.POTION,
        name: "Petite 86",
        icon: '🍺',
        description: "8 morts, 6 blessés, jpète ma bière, ma libellule",
        price: 6,
        consumable: true,
        stackable: true,
        stackCount: 99,
        effect: {
            type: EFFECT_TYPE.GAIN.HP,
            value: 5,
        }
    },
    potionSmallHP: {
        id: 'potionSmallHP',
        type: ITEM_TYPE.POTION,
        name: "Grosse bière",
        icon: '🍻',
        description: "C'est à partager.. sauf peut-être pour Polo pizza",
        price: 12,
        consumable: true,
        stackable: true,
        stackCount: 99,
        effect: {
            type: EFFECT_TYPE.GAIN.HP,
            value: 10,
        }
    },
    potionLittleMP: {
        id: 'potionLittleMP',
        type: ITEM_TYPE.POTION,
        name: "Pillule de mana",
        icon: '💊',
        description: "Pillule mais pas celle de ta copine lol",
        price: 6,
        consumable: true,
        stackable: true,
        stackCount: 99,
        effect: {
            type: EFFECT_TYPE.GAIN.MP,
            value: 5,
        },
    },
    potionSmallMP: {
        id: 'potionSmallMP',
        type: ITEM_TYPE.POTION,
        name: "Seringue de mana",
        icon: '💉',
        description: "À injecter dans les veines sinon ça marche pas",
        price: 12,
        consumable: true,
        stackable: true,
        stackCount: 99,
        effect: {
            type: EFFECT_TYPE.GAIN.MP,
            value: 10,
        },
    },
    potionSmallElixir:  {
        id: 'potionSmallElixir',
        type: ITEM_TYPE.POTION,
        name: "Elixir de vie",
        icon: '⚗️',
        description: "Bon pour le corps.. et l'esprit",
        price: 24,
        consumable: true,
        stackable: true,
        stackCount: 99,
        effect: {
            type: EFFECT_TYPE.GAIN.HP_MP,
            value: 10,
        },
    },
    potionBigElixir:  {
        id: 'potionBigElixir',
        type: ITEM_TYPE.POTION,
        name: "Elixir de vie à base de feu de joie",
        icon: '🔥',
        description: "Vous brûle la peau, mais ensuite ça va mieux quand même",
        price: 100,
        consumable: true,
        stackable: true,
        stackCount: 99,
        effect: {
            type: EFFECT_TYPE.GAIN.HP_MP,
            value: 50,
        },
    },
}

export default class Potion extends Item {

    constructor(
        potionData
    ) {
        super(
            ...Object.values(potionData)
        );

        this.effect = potionData.effect;
    }
}